import React, { Component } from "react";
import SettingsView from "./SettingsView";
import SettingsContextProvider from "./SettingsContext";

class Settings extends Component {
  render() {
    return (
      <SettingsContextProvider>
        <SettingsView />
      </SettingsContextProvider>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/settings/Settings.js